export const FETCH_HOSPITAL_SYSTEMS_START = 'FETCH_HOSPITAL_SYSTEMS_START';
export const FETCH_HOSPITAL_SYSTEMS_SUCCESS = 'FETCH_HOSPITAL_SYSTEMS_SUCCESS';
export const FETCH_HOSPITAL_SYSTEMS_FAILURE = 'FETCH_HOSPITAL_SYSTEMS_FAILURE';

export const FETCH_HOSPITAL_SYSTEM_START = 'FETCH_HOSPITAL_SYSTEM_START';
export const FETCH_HOSPITAL_SYSTEM_SUCCESS = 'FETCH_HOSPITAL_SYSTEM_SUCCESS';
export const FETCH_HOSPITAL_SYSTEM_FAILURE = 'FETCH_HOSPITAL_SYSTEM_FAILURE';

export const SET_HOSPITAL_SYSTEMS_QUERY_PARAMS = 'SET_HOSPITAL_SYSTEMS_QUERY_PARAMS';
